/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type StackCreatorRulesQueryVariables = {||};
export type StackCreatorRulesQueryResponse = {|
  +greenMachineStackRules: ?$ReadOnlyArray<?{|
    +id: string,
    +displayName: string,
    +operator: string,
  |}>
|};
export type StackCreatorRulesQuery = {|
  variables: StackCreatorRulesQueryVariables,
  response: StackCreatorRulesQueryResponse,
|};
*/


/*
query StackCreatorRulesQuery {
  greenMachineStackRules {
    id
    displayName
    operator
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "StackRuleType",
    "kind": "LinkedField",
    "name": "greenMachineStackRules",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "id",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "displayName",
        "storageKey": null
      },
      {
        "alias": null,
        "args": null,
        "kind": "ScalarField",
        "name": "operator",
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "StackCreatorRulesQuery",
    "selections": (v0/*: any*/),
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "StackCreatorRulesQuery",
    "selections": (v0/*: any*/)
  },
  "params": {
    "cacheID": "c04d4701174358802562906187d769a9",
    "id": null,
    "metadata": {},
    "name": "StackCreatorRulesQuery",
    "operationKind": "query",
    "text": "query StackCreatorRulesQuery {\n  greenMachineStackRules {\n    id\n    displayName\n    operator\n  }\n}\n"
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = 'd4a1bbfad8892f040af86b3a9da06036';

module.exports = node;
